

import "../../../Foundation/stylable/colors.st.css.js";
import "../../../Text/Text.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_180_0_Suffix";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_180_0_Suffix__root","charCount":"wds_1_180_0_Suffix__charCount"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-field-set-label-font-line-height-tiny":"--wds-field-set-label-font-line-height-tiny","wds-field-set-label-font-line-height-small":"--wds-field-set-label-font-line-height-small","wds-field-set-label-font-size-tiny":"--wds-field-set-label-font-size-tiny","wds-field-set-label-font-size-small":"--wds-field-set-label-font-size-small","wds-color-text-placeholder":"--wds-color-text-placeholder"}; 




